import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BRAND, IS_CLINIC } from "./platform/config";
import { CLINIC_FONT_STACK, COLORS } from "./assets/theme";

// One index.html serves both builds, so the per-product bits are set here.
document.title = `${BRAND.name} - ${BRAND.productName}`;
document
  .querySelector('meta[name="description"]')
  ?.setAttribute("content", `${BRAND.name} ${BRAND.productName}`);
if (IS_CLINIC) {
  document.documentElement.classList.add("platform-clinic");
  const fonts = document.createElement("link");
  fonts.rel = "stylesheet";
  fonts.href =
    "https://fonts.googleapis.com/css2?family=Figtree:wght@400;500;600;700;800&family=Noto+Sans:wght@400;500;700&display=swap";
  document.head.appendChild(fonts);
  document.body.style.fontFamily = CLINIC_FONT_STACK;
  document
    .querySelector('meta[name="theme-color"]')
    ?.setAttribute("content", COLORS.MainColor);
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <App />
);

reportWebVitals();

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((error) => {
      console.warn("Service worker registration failed", error);
    });
  });
}
